module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "width": "55%",
      "title": "Bulk Approve for On-Air",
      "destroy-on-close": "",
      "visible": _vm.internalVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.internalVisible = $event
      },
      "close": _vm.handleClose
    }
  }, [_c('div', {
    staticClass: "bulk-summary"
  }, [_c('div', {
    staticClass: "summary-stat"
  }, [_c('span', {
    staticClass: "summary-number"
  }, [_vm._v(_vm._s(_vm.notes.length))]), _vm._v(" "), _c('span', {
    staticClass: "summary-label"
  }, [_vm._v("Voice notes selected")])]), _vm._v(" "), _c('div', {
    staticClass: "summary-stat"
  }, [_c('span', {
    staticClass: "summary-number"
  }, [_vm._v(_vm._s(_vm.alreadyApproved.length))]), _vm._v(" "), _c('span', {
    staticClass: "summary-label"
  }, [_vm._v("Already on-air")])]), _vm._v(" "), _c('div', {
    staticClass: "summary-stat"
  }, [_c('span', {
    staticClass: "summary-number"
  }, [_vm._v(_vm._s(_vm.toApprove.length))]), _vm._v(" "), _c('span', {
    staticClass: "summary-label"
  }, [_vm._v("Will be approved")])])]), _vm._v(" "), (_vm.alreadyApproved.length > 0) ? _c('el-alert', {
    staticStyle: {
      "margin-bottom": "16px"
    },
    attrs: {
      "type": "warning",
      "closable": false,
      "show-icon": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n      " + _vm._s(_vm.alreadyApproved.length) + " voice note" + _vm._s(_vm.alreadyApproved.length !== 1 ? 's are' : ' is') + "\n      already on-air and will be skipped.\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "notes-list"
  }, _vm._l((_vm.notes), function(note) {
    return _c('div', {
      key: note.id,
      staticClass: "note-item",
      class: {
        'note-item--approved': note.approved
      }
    }, [_c('div', {
      staticClass: "note-item-left"
    }, [_c('i', {
      staticClass: "el-icon-user"
    }), _vm._v(" "), _c('span', {
      staticClass: "note-sender"
    }, [_vm._v(_vm._s(note.sender))]), _vm._v(" "), _c('span', {
      staticClass: "note-time"
    }, [_vm._v(_vm._s(_vm.formatDate(note.timestamp)))])]), _vm._v(" "), _c('div', {
      staticClass: "note-item-right"
    }, [(note.approved) ? _c('el-tag', {
      attrs: {
        "size": "mini",
        "type": "success",
        "effect": "dark"
      }
    }, [_c('i', {
      staticClass: "fa fa-podcast"
    }), _vm._v(" Already On Air\n        ")]) : (note.flagged) ? _c('el-tag', {
      attrs: {
        "size": "mini",
        "type": "danger",
        "effect": "plain"
      }
    }, [_c('i', {
      staticClass: "fa fa-flag"
    }), _vm._v(" Flagged\n        ")]) : _c('el-tag', {
      attrs: {
        "size": "mini",
        "type": "info",
        "effect": "plain"
      }
    }, [_c('i', {
      staticClass: "el-icon-check"
    }), _vm._v(" Ready to Approve\n        ")])], 1)])
  }), 0), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-position": "top",
      "size": "small"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Approving As"
    }
  }, [_c('el-input', {
    attrs: {
      "value": _vm.approvedBy,
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-user el-input__icon",
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Send On-Air To"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "Select on-air user"
    },
    model: {
      value: (_vm.computedOnAirUser),
      callback: function($$v) {
        _vm.computedOnAirUser = $$v
      },
      expression: "computedOnAirUser"
    }
  }, _vm._l((_vm.companyUsers), function(user) {
    return _c('el-option', {
      key: user.id,
      attrs: {
        "label": user.display_name,
        "value": user.id
      }
    }, [_c('span', [_vm._v(_vm._s(user.display_name))]), _vm._v(" "), (user.id === _vm.me.id) ? _c('span', {
      staticStyle: {
        "float": "right",
        "color": "#67c23a",
        "font-size": "12px"
      }
    }, [_c('i', {
      staticClass: "el-icon-user"
    }), _vm._v(" You\n          ")]) : _vm._e()])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Date of Approval"
    }
  }, [_c('el-input', {
    attrs: {
      "value": _vm.approvalDate,
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-date el-input__icon",
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Batch Comment (applies to all)"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "Add a reason or comment for this batch approval...",
      "rows": 3,
      "maxlength": "300",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.comments),
      callback: function($$v) {
        _vm.comments = $$v
      },
      expression: "comments"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "loading": _vm.loading,
      "disabled": _vm.toApprove.length === 0
    },
    on: {
      "click": _vm.handleApprove
    }
  }, [_vm._v("\n      Approve " + _vm._s(_vm.toApprove.length) + " Voice Note" + _vm._s(_vm.toApprove.length !== 1 ? 's' : '') + "\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ce2cbc2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/analytics/voiceIntelligence/modals/BulkApproveModal.vue
// module id = 3272
// module chunks = 3